const SPOTLIGHTS = [
  {
    tag: '日漫巅峰',
    title: '《进击的巨人》完结纪念特辑',
    desc: '十年连载画上句号，艾伦的命运终章引发全球热议，重温这部改变漫画历史的史诗巨作。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Japanese%20manga%20style%20illustration%20featuring%20a%20heroic%20character%20in%20dynamic%20action%20pose%2C%20dramatic%20composition%20with%20speed%20lines%2C%20warm%20coral%20and%20amber%20tones%2C%20cinematic%20lighting%2C%20detailed%20linework%2C%20manga%20panel%20aesthetic%2C%20clean%20warm%20cream%20abstract%20background&width=600&height=380&seq=sakura-carousel-01&orientation=landscape',
    alt: '进击的巨人完结纪念特辑，热血日漫经典史诗',
  },
  {
    tag: '韩漫新潮',
    title: '《我独自升级》热潮席卷全球',
    desc: '从网漫到动画，韩漫现象级作品如何征服全球读者，深度解析其成功之道与独特美学。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20digital%20art%20featuring%20a%20stylish%20modern%20character%20in%20urban%20setting%2C%20sleek%20illustration%20with%20soft%20warm%20lighting%2C%20coral%20and%20golden%20color%20scheme%2C%20polished%20digital%20painting%20style%2C%20clean%20composition%2C%20warm%20cream%20minimal%20background&width=600&height=380&seq=sakura-carousel-02&orientation=landscape',
    alt: '我独自升级韩漫热潮，全球读者追捧的现象级作品',
  },
  {
    tag: '国漫崛起',
    title: '《一人之下》第五季重磅回归',
    desc: '异人世界的冒险继续！国漫标杆之作携全新篇章回归，传统文化与现代叙事的完美融合。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20martial%20arts%20character%20in%20traditional%20clothing%2C%20dynamic%20brushstroke%20effects%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20elegant%20composition%2C%20ink%20wash%20painting%20influence%2C%20clean%20warm%20cream%20background%2C%20artistic%20atmosphere&width=600&height=380&seq=sakura-carousel-03&orientation=landscape',
    alt: '一人之下第五季回归，国漫标杆之作全新篇章',
  },
  {
    tag: '经典重温',
    title: '《灌篮高手》剧场版特别企划',
    desc: '青春不散场！重温湘北与山王的世纪对决，经典之所以为经典，在于每一次回顾都有新的感动。',
    img: 'https://readdy.ai/api/search-image?query=Retro%20classic%20manga%20style%20basketball%20scene%20with%20dynamic%20movement%2C%20nostalgic%2090s%20anime%20aesthetic%2C%20warm%20vintage%20coral%20tones%2C%20dramatic%20composition%20with%20action%20lines%2C%20clean%20warm%20cream%20background%2C%20emotional%20sports%20moment&width=600&height=380&seq=sakura-carousel-04&orientation=landscape',
    alt: '灌篮高手剧场版特别企划，经典篮球漫画重温',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
            热门精选
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            不容错过的漫画专题与深度解读
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {SPOTLIGHTS.map((item, idx) => (
            <article
              key={idx}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/70 flex flex-col sm:flex-row cursor-pointer"
            >
              <div className="sm:w-2/5 shrink-0">
                <div className="relative w-full aspect-[16/10] sm:aspect-[4/3] sm:h-full overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.alt}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <span className="inline-block px-2.5 py-0.5 text-xs font-medium rounded-full bg-accent-100 text-accent-800 mb-2 self-start">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-semibold text-foreground-950 font-heading mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-xs text-primary-500 mt-3 font-medium">
                  阅读专题 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}